import React from 'react';
import NavFurtherAction from './nav-further-action';
import Logo from './navbar-footer-logo';
import {USER_TYPE_REP, USER_TYPE_RETAILER} from '../../../data/userTypes';
import {tradeSiteDisabled} from '../../../utils/toggles';

const NavBarFooter = ({type}) => {
  const uriPrefix = type === USER_TYPE_REP ? '/team' : '';
  return (
    <div className={`footer ${tradeSiteDisabled() ? 'logo' : 'no-logo'}`} id="navbar-footer">
      <div className="nav-further-actions">
        <NavFurtherAction href={`${uriPrefix}/my-profile`} icon="user" tooltip="My Profile"/>
        <NavFurtherAction href={`${uriPrefix}/content-pages/terms-conditions`} icon="edit" tooltip="Terms & Conditions"/>
        <NavFurtherAction href={`${uriPrefix}/about-ignite`} icon="question" tooltip="FAQs"/>
        <NavFurtherAction href={`${uriPrefix}/content-pages/privacy-policy`} icon="eye" tooltip="Privacy Policy"/>
      </div>
      { tradeSiteDisabled() ? <Logo/> : null}
    </div>
  );
};

NavBarFooter.defaultProps = {
  type: USER_TYPE_RETAILER,
};

export default NavBarFooter;



// WEBPACK FOOTER //
// ./src/components/layout/navbar/navbar-footer.jsx